import React, { useState, useEffect } from "react";
import logo from "./logo.svg";
import "../App.css";
import Header from "../component/Header";
import ModelItem from "../component/ModelItem";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
function Model() {
  let { t } = useTranslation();
  const [loader, setLoader] = useState(true);
  const [total, setTotal] = useState(0);
  const onUpdateTotal = (t: any) => {
    setTotal(t);
  };
  const onNext = () => {
    if (sessionStorage.getItem("model")) {
      window.location.href = "/ae/ar/choose-your-refrigerator/attention";
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="App container-fuild">
      <Header />
      <div className="container-fuild px-3">
        <div className="container-content model-container-content">
          <div className="container-block">
            {loader ? (
              <div className="loader-block">
                <div className="custom-loader"></div>
                <p className="mb-0">{parse(t("progress"))}</p>
              </div>
            ) : (
              <>
                <p>{parse(t("model_desc"))}</p>
                <div className="mt-2 px-2">
                  <div className="container m-auto models-list   px-0 ">
                    <ModelItem onUpdateTotal={onUpdateTotal} />
                  </div>
                </div>
              </>
            )}
          </div>
          <ul className="step">
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li className="active">4</li>
            <li>5</li>
          </ul>
        </div>
        {!loader ? (
          <div className="row w-100 mx-0 mb-5">
            <div className="col-12 text-center">
              <a
                className="btn btn-back"
                href="/ae/ar/choose-your-refrigerator/placement"
              >
                {t("back")}
              </a>
              <button className="btn btn-next" onClick={() => onNext()}>
                {t("next")}
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default Model;
